import { render, staticRenderFns } from "./OSmsConfirmationComp.vue?vue&type=template&id=3fad805a&"
import script from "./OSmsConfirmationComp.vue?vue&type=script&lang=js&"
export * from "./OSmsConfirmationComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports